module.exports = __webpack_public_path__ + "img/our-service.e62a720b.png";